import { Upload } from 'antd';
import { DraggerProps } from 'antd/lib/upload/Dragger';
import cn from 'classnames';
import * as React from 'react';

import s from './BaseDndUploader.module.scss';

export type BaseDndUploaderProps = {
  containerClassName?: string;
} & DraggerProps;

/** Обёртка над драггером для сброса стилей */
const BaseDndUploader: React.FC<BaseDndUploaderProps> = (props) => {
  return (
    <div className={cn(s.dndUploader, props.containerClassName)}>
      <Upload.Dragger {...props} />
    </div>
  );
};

export default BaseDndUploader;
